<template>
  <div>
    <img :src="imageSrc" @click="onClick">
  </div>
</template>

<script>

const fx = require('glfx-es6/lib');

export default {
  name: 'warpGlfx',
  inject: ['canvasImage'],
  props: {
    warpInfo: {
      type: Object,
      default: () => {}
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    warpName: {
      type: String,
      default: 'noWarp'
    }
  },
  data() {
    return {
      imageSrc: ''
    }
  },
  methods: {
    async warpCanvas() {
      const canvas = fx.canvas();
      const texture = canvas.texture(this.canvasImage());
      let draw = canvas.draw(texture);
      const method = this.warpInfo['method'];
      if (method) {
        this.warpInfo['combinations'].forEach(element => {
          draw = draw[method].apply(draw, element);
        });
      }
      draw.update();

      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      this.imageSrc = URL.createObjectURL(blob);

      this.$emit('warpLoaded');
      if (this.isSelected) {
        this.onClick();
      }
      texture.destroy();
    },
    onClick() {
      this.$emit('warpSelected', this.imageSrc, this.warpName);
    },
  },
  mounted() {
    this.warpCanvas();
  },
}
</script>
